module.exports = __webpack_public_path__ + "img/gift8.5fae888c.png";